import { Link } from 'react-router-dom'

import { Icon, IconNameAndCategoryString } from '../../Icon'
import Badge from './Badge'
import Label from './Label'
import Paragraph from './Paragraph'

export interface FieldLink {
    to: string
    title: string
    subtitle?: string
    icon?: IconNameAndCategoryString
    disabled?: boolean
    count?: number
}

type NavFieldProps = {
    link: FieldLink
    onClick?: () => void
}

const NavField = ({ link, onClick }: NavFieldProps) => {
    return (
        <Link
            to={link.to}
            className={`focus-visible:border-info-400 -mx-4 flex items-center gap-4 rounded-lg border-2 border-white p-4 no-underline hover:no-underline focus:no-underline focus-visible:border-2 focus-visible:outline-hidden active:bg-white active:bg-linear-to-b active:from-black/8 active:to-black/8 ${
                link.disabled
                    ? 'pointer-events-none opacity-30'
                    : 'text-gray-600 hover:bg-linear-to-b hover:from-black/4 hover:to-black/4 hover:text-gray-600 focus:text-gray-600'
            }`}
            onClick={onClick}
            aria-disabled={link.disabled}
        >
            {link.icon && (
                <span className="text-primary-700 flex size-12 items-center justify-center">
                    <Icon icon={link.icon} background="round" />
                </span>
            )}
            <div className="flex flex-col gap-1">
                <Label className="cursor-pointer text-gray-700">{link.title}</Label>
                {link.subtitle && (
                    <Paragraph size="sm" className="cursor-pointer text-gray-600">
                        {link.subtitle}
                    </Paragraph>
                )}
            </div>
            {link.count !== undefined && <Badge value={link.count} />}
            <span className="ml-auto flex size-6 items-center text-gray-500">
                <Icon icon="chevronRight.large" shouldInheritColor />
            </span>
        </Link>
    )
}

export default NavField
